import React from "react";

import { Localized } from "fluent-react/compat";

function ChoiceCurrency({ handleCurrency, currency }) {
  const handleChange = (event) => {
    handleCurrency(event.target.value);
  };
  return (
    <div className="container-select-currency">
      <h3>
        <Localized id="tr-admin-choice-curreny" />
      </h3>
      <select
        value={currency}
        className="select-currency"
        onChange={handleChange}
      >
        <option value="EUR">€</option>
        <option value="CHF">CHF</option>
      </select>
    </div>
  );
}

export default ChoiceCurrency;
